"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingFileNameError = void 0;
const custom_error_1 = require("./custom-error");
class MissingFileNameError extends custom_error_1.CustomError {
    constructor() {
        super('Filename is missing from test result', custom_error_1.ERROR_CODES.MissingFileName);
    }
}
exports.MissingFileNameError = MissingFileNameError;
//# sourceMappingURL=missing-file-name.js.map